///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.formatter = abcsetup.formatter || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.formatter = {
    /**
     * Format the given value as currency.
     *
     * @param amount
     * @returns {string}
     * @private
     */
    currency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(amount);
    },

    /**
     * Format the given value as a number.
     *
     * @param {string|number} value
     * @param {number} decimals
     * @param {boolean} useGrouping
     * @returns {string}
     * @private
     */
    number(value, decimals = 0, useGrouping = true) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimals,
            useGrouping,
        }).format(value);
    },
}
